import { Divider } from '@advanza/ui'
import Card from 'components/Card'
import SyncLocalizedServiceSubscriptionsButton from 'features/localizedServiceMappings/SyncLocalizedServiceSubscriptionsButton'
import OptionsMappingEditor from './OptionsMappingEditor'

interface LocalizedServiceCardProps {
    service: {
        service_id: number
        language_code: string | null
        canonical_service_id: number | null
        questions: number[] | null
    }
}

const LocalizedServiceCard = ({ service }: LocalizedServiceCardProps) => {
    if (!service.language_code || !service.canonical_service_id) {
        return null
    }

    return (
        <Card header="Localized Option Mappings" icon="translate" useToggle>
            <Divider m />
            <OptionsMappingEditor
                serviceId={service.service_id}
                canonicalServiceId={service.canonical_service_id}
                currentServiceQuestionIds={service.questions}
            />
            <Divider m />
            <SyncLocalizedServiceSubscriptionsButton service={service} />
        </Card>
    )
}

export default LocalizedServiceCard
